import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
	import DialogBox from '@cnamts/vue-dot/src/elements/DialogBox';

	import { Professional } from '@/types/professional';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'radiologue-card',
  props: {
    structureProfessionalList: null
  },
  setup(__props: any) {

	

	const isDialogOpen = ref(false);

return { __sfc: true,isDialogOpen, DialogBox }
}

})